import { createFileRoute } from '@tanstack/react-router';
import { ExpensesPage } from '../features/expenses/ExpensesPage';
import { validateMonthSearch } from '../lib/months';

export const Route = createFileRoute('/expenses')({
  validateSearch: validateMonthSearch,
  component: ExpensesPage,
});
